var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bdc"},[_c('div',{ref:"chartEl",staticClass:"bdc-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }